import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLastCampaignSummaryPage } from '../store/actions/route-actions';
import AddIcon from '@material-ui/icons/Add';
import Header from './Header';
import { useHistory } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import CampaignDashboardTable from '../components/CampaignSummary/CampaignDashboardTable';
import CampaignFooter from '../components/CampaignSummary/CampaignFooter';
import CreateCampaign from '../components/CampaignSummary/CreateCampaign';
import ShareCampaign from '../components/CampaignSummary/ShareCampaign';
import SharedList from '../components/CampaignSummary/SharedList';
import { fetchCampaigns } from '../store/actions/campaign-summary-actions';

const CampaignSummary = props => {
  const dispatch = useDispatch();
  const history = useHistory();

  const campaigns = useSelector(state => state.campaign.campaigns);

  const shareList = useSelector(state => state.campaign.shareList);
  const shareListLoading = useSelector(
    state => state.campaign.shareListLoading
  );

  const [shareListState, setShareListState] = useState(shareList);

  const accountRoles = useSelector(
    state =>
      (state.account.accountOverviewData.account &&
        state.account.accountOverviewData.account.roles) ||
      []
  );

  const enableAudienceSummary = useSelector(
    state =>
      state.account.accountOverviewData.client &&
      state.account.accountOverviewData.client.props.enableAudienceSummary
  );

  const handleRedirect = url => {
    history.push(url);
  };

  useEffect(() => {
    dispatch(setLastCampaignSummaryPage('/campaign-summary'));
    dispatch(fetchCampaigns());
  }, []);

  useEffect(() => {
    setShareListState(shareList);
  }, [shareList]);

  return (
    <div>
      <Header />
      <div style={{ position: 'relative' }}>
        <div className="CampaignSummary_top-background" />
        <div className="CampaignSummary_content-background" />

        <div className="CampaignSummary_container">
          <div className="CampaignSummary_container_top-area">
            <div className="CampaignSummary_container_title">
              {window.location.pathname === '/campaign-summary' &&
                `Campaign Summary Dashboard`}
              {window.location.pathname === '/create-campaign' &&
                `Create Post Campaign Audience Summary`}
              {window.location.pathname === '/share-campaign' && `Share Report`}
            </div>

            {/* create button only in dashboard */}
            {window.location.pathname === '/campaign-summary' &&
              accountRoles.includes('Viewer') === false &&
              enableAudienceSummary === true && (
                <div className="CampaignSummary_container_create-campaign-btn-area">
                  <div
                    className="CampaignSummary_container_create-campaign-btn"
                    onClick={() => handleRedirect('/create-campaign')}
                  >
                    <AddIcon />
                    <div className="CampaignSummary_container_create-campaign-btn-text">
                      Create New Campaign
                    </div>
                  </div>
                </div>
              )}

            {window.location.pathname === '/share-campaign' && (
              <div className="CampaignSummary_container_create-campaign-btn-area">
                <div
                  className="CampaignSummary_container_create-campaign-btn"
                  style={{ width: '137.27px' }}
                  onClick={() => console.log('/create-campaign')}
                >
                  <AddIcon />
                  <div className="CampaignSummary_container_create-campaign-btn-text">
                    Send invite
                  </div>
                </div>
              </div>
            )}
          </div>

          {window.location.pathname === '/campaign-summary' && (
            <div className="CampaignSummary_container_full-content-area">
              <CampaignDashboardTable campaigns={campaigns} />
            </div>
          )}

          {window.location.pathname === '/create-campaign' && (
            <div className="CampaignSummary_container_70perecent-content-area">
              <CreateCampaign />
            </div>
          )}

          {window.location.pathname === '/share-campaign' && (
            <div className="CampaignSummary_container_70perecent-content-area">
              {shareListLoading ? (
                <div>
                  <div className="ShareCampaign_container">
                    <div className="ShareCampaign_first-invitation">
                    <Spinner size="sm" color="dark" />
                    </div>
                  </div>
                </div>
              ) : shareListState && shareListState.length > 0 ? (
                <SharedList data={shareListState} />
              ) : (
                <ShareCampaign />
              )}
            </div>
          )}

          <div onClick={() => handleRedirect('/campaign-signin')}>Sign in</div>
          <div
            onClick={() =>
              handleRedirect(
                '/signup?campaignType=audienceSummary&shareId=621c8d759d417838f827de7e&campaignId=61e7ec398810fc908823513b'
              )
            }
          >
            Sign up
          </div>

          <CampaignFooter />
        </div>
      </div>
    </div>
  );
};

export default CampaignSummary;
